import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
    FaFemale,
    FaMale,
    FaThermometerHalf,
    FaGraduationCap,
    FaChartLine,
    FaUserTag,
    FaBuilding,
    FaCalendarAlt,
    FaCalendarDay,
    FaPiggyBank
} from "react-icons/fa";
import { endash } from "./QuoteCell";
import { SENTIMENT } from "../../modules/drivers";
import * as drivers from "../../modules/drivers";
import styles from "../../styles/components/DriverQuotesFilter.css";

export const FILTER_ITEMS = {
    gender: [
        { label: "Female", value: 7, isChecked: true },
        { label: "Male", value: 8, isChecked: true },
    ],
    age: [
        { value: 11, label: `18${endash}24`, isChecked: true },
        { value: 10, label: `25${endash}34`, isChecked: true },
        { value: 15, label: `35${endash}44`, isChecked: true },
        { value: 14, label: `45${endash}54`, isChecked: true },
        { value: 13, label: `55+`, isChecked: true },
    ],
    income: [
        { value: 2, label: `$0${endash}$49k`, isChecked: true },
        { value: 6, label: `$50k${endash}$99k`, isChecked: true },
        { value: 5, label: `$100k${endash}$149k`, isChecked: true },
        { value: 4, label: `$150k+`, isChecked: true },
    ],
    education: [
        { value: 16, label: "Some High School", isChecked: true },
        { value: 17, label: "High School Diploma/GED", isChecked: true },
        { value: 18, label: "Some College", isChecked: true },
        { value: 19, label: "Associate's Degree", isChecked: true },
        { value: 20, label: "Bachelor's Degree or Higher", isChecked: true },
    ],
    b2bAge: [
        {
            value: "Less than 1 year",
            label: "Less than 1 year",
            isChecked: true,
        },
        { value: "1-2 years", label: `1${endash}2 years`, isChecked: true },
        { value: "3-5 years", label: `3${endash}5 years`, isChecked: true },
        { value: "6-9 years", label: `6${endash}9 years`, isChecked: true },
        { value: "10+ years", label: `10+ years`, isChecked: true },
    ],
    b2bRevenue: [
        {
            value: "$50k - <$250k",
            label: `$50k ${endash} <$250k`,
            isChecked: true,
        },
        {
            value: "250k - <$500k",
            label: `250k ${endash} <$500k`,
            isChecked: true,
        },
        {
            value: "$500k - <$750k",
            label: `$500k ${endash} <$750k`,
            isChecked: true,
        },
        {
            value: "$750k - <$1M",
            label: `$750k ${endash} <$1M`,
            isChecked: true,
        },
        { value: "$1M - <$2M", label: `$1M ${endash} <$2M`, isChecked: true },
        { value: "$2M - <$5M", label: `$2M ${endash} <$5M`, isChecked: true },
        { value: "$5M - <$10M", label: `$5M ${endash} <$10M`, isChecked: true },
        {
            value: "$10M - <$25M",
            label: `$10M ${endash} <$25M`,
            isChecked: true,
        },
        {
            value: "$25M - <$50M",
            label: `$25M ${endash} <$50M`,
            isChecked: true,
        },
        {
            value: "$50M - <$100M",
            label: `$50M ${endash} <$100M`,
            isChecked: true,
        },
        {
            value: "$100M - <$500M",
            label: `$100M ${endash} <$500M`,
            isChecked: true,
        },
        {
            value: "$500M - <$1B",
            label: `$500M ${endash} <$1B`,
            isChecked: true,
        },
        { value: "$1B - <$10B", label: `$1B ${endash} <$10B`, isChecked: true },
    ],
    b2bRole: [
        { value: "Entry Level", label: "Entry Level", isChecked: true },
        {
            value: "Home Based Business Owner",
            label: "Home Based Business Owner",
            isChecked: true,
        },
        {
            value: "Front Line Management",
            label: "Front Line Management",
            isChecked: true,
        },
        {
            value: "Experienced: Professional or Non-Management",
            label: "Experienced: Professional or Non-Management",
            isChecked: true,
        },
        {
            value: "Middle Management",
            label: "Middle Management",
            isChecked: true,
        },
        {
            value: "Senior Management",
            label: "Senior Management",
            isChecked: true,
        },
        { value: "Business Owner", label: "Business Owner", isChecked: true },
        { value: "Other", label: "Other", isChecked: true },
    ],
    b2bSize: [
        { value: "1", label: "1", isChecked: true },
        { value: "2-5", label: `2${endash}5`, isChecked: true },
        { value: "6-9", label: `6${endash}9`, isChecked: true },
        { value: "10-49", label: `10${endash}49`, isChecked: true },
        { value: "50-99", label: `50${endash}99`, isChecked: true },
        { value: "100-249", label: `100${endash}249`, isChecked: true },
        { value: "250-499", label: `250${endash}499`, isChecked: true },
        { value: "500-999", label: `500${endash}999`, isChecked: true },
        {
            value: "1,000-2,499",
            label: `1,000${endash}2,499`,
            isChecked: true,
        },
        {
            value: "2,500-4,999",
            label: `2,500${endash}4,999`,
            isChecked: true,
        },
        {
            value: "5,000-9,999",
            label: `5,000${endash}9,999`,
            isChecked: true,
        },
        {
            value: "10,000-24,999",
            label: `10,000${endash}24,999`,
            isChecked: true,
        },
    ],
    sentiment: [
        { value: SENTIMENT.positive, label: "Positive", isChecked: true },
        { value: SENTIMENT.negative, label: "Negative", isChecked: true },
    ],
};

export function FilterField({ value, label, isChecked, onChange }) {
    const id = `filter-${value}`;
    return (
        <div key={value} className={styles.filterField}>
            <input
                type="checkbox"
                id={id}
                value={value}
                checked={isChecked}
                onChange={onChange}
            />
            <label htmlFor={id}>{label}</label>
        </div>
    );
}

FilterField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isChecked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

export function FilterFields({ items, onChange }) {
    return (
        <div className={styles.filterFields}>
            {items.map(({ value, label, isChecked }) => (
                <FilterField
                    key={value}
                    value={value}
                    label={label}
                    isChecked={isChecked}
                    onChange={onChange}
                />
            ))}
        </div>
    );
}

FilterFields.propTypes = {
    onChange: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            isChecked: PropTypes.bool.isRequired,
        }).isRequired
    ),
};

function FilterTitle({ title, icons }) {
    return (
        <h3 className={styles.filterTitle}>
            <div className={styles.icons}>
                {icons.map((icon, index) =>
                    React.createElement(icon, { key: index })
                )}
            </div>
            {title}
        </h3>
    );
}

FilterTitle.propTypes = {
    title: PropTypes.string.isRequired,
    icons: PropTypes.arrayOf(PropTypes.object).isRequired,
};

function Filter({ title, icons, items, onChange }) {
    return (
        <div className={styles.filter}>
            <FilterTitle title={title} icons={icons} />
            <FilterFields items={items} onChange={onChange} />
        </div>
    );
}

Filter.propTypes = {
    title: PropTypes.string.isRequired,
    icons: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            isChecked: PropTypes.bool.isRequired,
        }).isRequired
    ),
};

class DriverQuotesFilter extends React.Component {
    componentWillUnmount() {
        this.props.resetFilters();
    }

    onChangeSegment = (e) => {
        const value = parseInt(e.target.value, 10);
        if (e.target.checked) {
            this.props.addSegmentFilter(value);
        } else {
            this.props.removeSegmentFilter(value);
        }
    };

    onChangeB2B = (e) => {
        if (e.target.checked) {
            this.props.addB2bFilter(e.target.value);
        } else {
            this.props.removeB2bFilter(e.target.value);
        }
    };

    onChangeSentiment = (e) => {
        const { value, checked } = e.target;
        if (checked) {
            this.props.addSentimentFilter(value);
        } else {
            this.props.removeSentimentFilter(value);
        }
    };

    render() {
        return (
            <div className={styles.card}>
                <h2 className={styles.cardTitle}>Filter Quotes</h2>
                <div className={styles.cardContent}>
                    {!this.props.showB2bFilters && (
                        <div>
                            <Filter
                                key="gender-filter"
                                title="Gender"
                                icons={[FaFemale, FaMale]}
                                items={this.props.genderItems}
                                onChange={this.onChangeSegment}
                            />
                            <Filter
                                title="Age"
                                key="age-filter"
                                icons={[FaCalendarAlt]}
                                items={this.props.ageItems}
                                onChange={this.onChangeSegment}
                            />
                            <Filter
                                title="Income"
                                key="income-filter"
                                icons={[FaPiggyBank]}
                                items={this.props.incomeItems}
                                onChange={this.onChangeSegment}
                            />
                            <Filter
                                title="Education"
                                key="education-filter"
                                icons={[FaGraduationCap]}
                                items={this.props.educationItems}
                                onChange={this.onChangeSegment}
                            />
                        </div>
                    )}
                    {this.props.showB2bFilters && (
                        <div>
                            <Filter
                                title="Business Age"
                                key="business-age-filter"
                                icons={[FaCalendarDay]}
                                items={this.props.b2bAgeItems}
                                onChange={this.onChangeB2B}
                            />
                            <Filter
                                title="Revenue"
                                key="revenue-filter"
                                icons={[FaChartLine]}
                                items={this.props.b2bRevenueItems}
                                onChange={this.onChangeB2B}
                            />
                            <Filter
                                title="Role"
                                key="role-filter"
                                icons={[FaUserTag]}
                                items={this.props.b2bRoleItems}
                                onChange={this.onChangeB2B}
                            />
                            <Filter
                                title="Company Size"
                                key="company-size-filter"
                                icons={[FaBuilding]}
                                items={this.props.b2bSizeItems}
                                onChange={this.onChangeB2B}
                            />
                        </div>
                    )}
                    {this.props.showSentiment && (
                        <Filter
                            key="sentiment-filter"
                            title="Sentiment"
                            icons={[FaThermometerHalf]}
                            items={this.props.sentimentItems}
                            onChange={this.onChangeSentiment}
                        />
                    )}
                    <button
                        key="reset-button"
                        className={styles.resetButton}
                        disabled={!this.props.canReset}
                        onClick={this.props.resetFilters}
                    >
                        Reset
                    </button>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const {
        selectedSegments,
        selectedSentiments,
        selectedB2bFilters,
    } = state.drivers;

    const genderItems = FILTER_ITEMS.gender.map((item) => {
        return {
            ...item,
            isChecked: selectedSegments.includes(item.value),
        };
    });

    const ageItems = FILTER_ITEMS.age.map((item) => {
        return {
            ...item,
            isChecked: selectedSegments.includes(item.value),
        };
    });

    const incomeItems = FILTER_ITEMS.income.map((item) => {
        return {
            ...item,
            isChecked: selectedSegments.includes(item.value),
        };
    });

    const educationItems = FILTER_ITEMS.education.map((item) => {
        return {
            ...item,
            isChecked: selectedSegments.includes(item.value),
        };
    });

    const b2bAgeItems = FILTER_ITEMS.b2bAge.map((item) => {
        return { ...item, isChecked: selectedB2bFilters.includes(item.value) };
    });

    const b2bRevenueItems = FILTER_ITEMS.b2bRevenue.map((item) => {
        return { ...item, isChecked: selectedB2bFilters.includes(item.value) };
    });

    const b2bRoleItems = FILTER_ITEMS.b2bRole.map((item) => {
        return { ...item, isChecked: selectedB2bFilters.includes(item.value) };
    });

    const b2bSizeItems = FILTER_ITEMS.b2bSize.map((item) => {
        return { ...item, isChecked: selectedB2bFilters.includes(item.value) };
    });

    const sentimentItems = FILTER_ITEMS.sentiment.map((item) => {
        return {
            ...item,
            isChecked: selectedSentiments.includes(item.value),
        };
    });

    const canReset = [
        ...sentimentItems,
        ...genderItems,
        ...ageItems,
        ...incomeItems,
        ...educationItems,
        ...b2bAgeItems,
        ...b2bRevenueItems,
        ...b2bRoleItems,
        ...b2bSizeItems,
    ].some((item) => !item.isChecked);

    return {
        canReset,
        ageItems,
        genderItems,
        incomeItems,
        educationItems,
        b2bAgeItems,
        b2bRevenueItems,
        b2bRoleItems,
        b2bSizeItems,
        sentimentItems,
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        addSegmentFilter: (segmentId) =>
            dispatch(drivers.addSegmentFilter(segmentId)),
        removeSegmentFilter: (segmentId) =>
            dispatch(drivers.removeSegmentFilter(segmentId)),
        addSentimentFilter: (sentiment) =>
            dispatch(drivers.addSentimentFilter(sentiment)),
        removeSentimentFilter: (sentiment) =>
            dispatch(drivers.removeSentimentFilter(sentiment)),
        addB2bFilter: (b2bFilter) => dispatch(drivers.addB2bFilter(b2bFilter)),
        removeB2bFilter: (b2bFilter) =>
            dispatch(drivers.removeB2bFilter(b2bFilter)),
        resetFilters: () => dispatch(drivers.resetFilters()),
    };
}

DriverQuotesFilter.propTypes = {
    showSentiment: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverQuotesFilter);



// WEBPACK FOOTER //
// ./src/components/Results/DriverQuotesFilter.js